// Хотя бы один заполненный результат
import { cableHasResult } from './ReportCheckListWorkResultsTypes.vue/ReportCheckListCable/ReportCheckListCable.js'

export function technologicalOperationHasResult (technologicalOperation, report, workType) {
  let hasResult = false
  const workResultsTypes = technologicalOperation.workResultsTypes
  if (technologicalOperation.key === 'mrokrComponentsCountOp') { // 'Кол-во отремонтированных компонентов'
    const mainWorkResultType = workResultsTypes.find(workResultsType => workResultsType.key === 'сountRes' || workResultsType.key === 'soEquipmentCountRes')
    const techOpResult = mainWorkResultType.resultValues[0].value
    hasResult = techOpResult != null
  } else if (technologicalOperation.key === 'mrokrRemontJOp') { // 'Журнал ремонта'
    const mainWorkResultType = workResultsTypes.find(workResultsType => workResultsType.key === 'RemontJRes')
    const techOpResult = mainWorkResultType.resultValues[0].value
    hasResult = remontJResultHasResult(techOpResult)
  } else if (technologicalOperation.key === 'beacon624Op') { // 'Инициализация QR-кода' (СУП)
    const serialNumberResultType = workResultsTypes.find(workResultsType => workResultsType.key === 'beaconSerialNumberInPhotoRes')
    const serialNumber = serialNumberResultType.resultValues[0].value

    const qrPhotoResultType = workResultsTypes.find(workResultsType => workResultsType.key === 'beaconQRPhotoRes')
    const qrPhotos = qrPhotoResultType.resultValues[0].value

    if (serialNumber != null && serialNumber.length && /^[a-zа-ё0-9]+$/i.test(serialNumber)) { // Серийный номер должен состоять только из цифр и букв
      hasResult = filesHasResult(qrPhotos)
      // const qrPhotoId = qrPhotos[0]
      // const qrPhoto = report.documents.find(document => document.id === qrPhotoId)
      // hasResult = qrPhoto != null
    }
  } else {
    // eslint-disable-next-line
    outerLoop: for (const workResultsType of workResultsTypes) {
      for (const resultValue of workResultsType.resultValues) {
        if (resultValue.value != null && resultValue.value !== '') {
          if (resultValue.fieldType === 'formdata') {
            if (resultValue.formType === 'auditDtResults') {
              hasResult = auditDtHasResult(resultValue.value)
            } else if (resultValue.formType === 'camMetroResult') {
              hasResult = camMetroResultHasResult(resultValue.value)
            } else if (resultValue.formType === 'remontJResult') {
              hasResult = remontJResultHasResult(resultValue.value)
            } else if (resultValue.formType === 'soDirTable') {
              hasResult = soDirTableHasResult(resultValue.value)
            } else if (resultValue.formType === 'soStands') {
              hasResult = soStandsResultHasResult(resultValue.value)
            } else if (resultValue.formType === 'cableMount' || resultValue.formType === 'cableDemount') {
              hasResult = cableHasResult(resultValue.value, resultValue)
            } else if (resultValue.formType === 'valueConstruction') {
              hasResult = valueConstructionHasResult(resultValue.value, report)
            } else if (resultValue.formType === 'ptoSmeta') {
              hasResult = ptoSmetaHasResult(resultValue.value, report)
            }
          } else if (resultValue.fieldType === 'file' || resultValue.fieldType === 'image') {
            hasResult = filesHasResult(resultValue.value)
          } else if (resultValue.fieldType == 'location') {
            hasResult = locationHasResult(resultValue.value)
          } else if (resultValue.fieldType == 'object') {
            hasResult = resultValue.value && !!resultValue.value.id
          } else if (resultValue.fieldType == 'ref') {
            hasResult = resultValue.value && !!resultValue.value.id
          } else if (resultValue.fieldType == 'combobox') {
            hasResult = resultValue.value && resultValue.value.length > 0
          } else {
            hasResult = true
          }
          if (hasResult) {
            // eslint-disable-next-line
            break outerLoop
          }
        }
      }
    }
  }
  return hasResult
}

function auditDtHasResult (value) {
  let hasResult = false

  if (value.directions) {
    for (const direction of value.directions) {
      if (direction.audit.data) {
        for (let j = 0; j < direction.audit.data.length; j++) {
          if (direction.audit.data[j] && direction.tperiods[j]) {
            hasResult = true
            break
          }
        }
      }
    }
  }

  return hasResult
}

function filesHasResult (value) {
  return value && value.length > 0
}

function camMetroResultHasResult (value) {
  let hasResult = false

  if (value && value.length) {
    for (const tgGroup of value) {
      for (const subgroup of tgGroup.subgroups) {
        for (const cam of subgroup.cams) {
          hasResult = cam && (!!cam.camId || cam.photoBefore.length !== 0 || cam.photoAfter.length !== 0)
        }
      }
    }
  }

  return hasResult
}

function remontJResultHasResult (value) {
  let hasResult = false

  if (value && value.length) {
    for (const rec of value) {
      hasResult = rec && (rec.comment != null && rec.comment != '' || rec.photo.length !== 0)
    }
  }

  return hasResult
}

function soDirTableHasResult (value) {
  return value && value.dirNum && value.dirNum.length !== 0
}

function soStandsResultHasResult (value) {
  let hasResult = false

  if (value && value.length) {
    for (const stand of value) {
      hasResult = stand && (stand.objectType || stand.photo.length !== 0 || stand.photoQr.length !== 0)
    }
  }

  return hasResult
}

function valueConstructionHasResult (value, report) {
  const thisReportValue = value.find(val => val.reportId === report.id)
  return !!thisReportValue && !!thisReportValue.value
}

function ptoSmetaHasResult (value, report) {
  let hasResult = false

  hasResult = value.length > 0

  return hasResult
}

function locationHasResult (value) {
  if (value && Array.isArray(value) && value.length) {
    if (Array.isArray(value[0]) && value[0].length == 2) {
      return value[0][0] != null && value[0][0] !== '' && value[0][1] != null && value[0][1] !== ''
    }
  }
  return false
}
